import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorYellow, colorYellowDark } from 'styles/layout/colors';
const IconStarFull = t0 => {
  const $ = _c(8);
  const {
    className: t1,
    fill: t2,
    height: t3,
    stroke: t4,
    width: t5
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const fill = t2 === undefined ? colorYellow : t2;
  const height = t3 === undefined ? "16px" : t3;
  const stroke = t4 === undefined ? colorYellowDark : t4;
  const width = t5 === undefined ? "16px" : t5;
  let t6;
  if ($[0] !== fill || $[1] !== stroke) {
    t6 = <path d="M9.945 4.62l-.018-.039L8.435.768C8.264.378 7.793.362 7.68.67L6.077 4.532c-.27.547-.692.902-1.197.9l-3.964.356c-.424.042-.573.58-.241.916l2.928 2.69c.385.389.526.923.398 1.44l-.88 4c-.091.459.318.76.656.547l3.425-2.128c.434-.292 1.096-.292 1.514-.01l3.443 2.14c.336.212.745-.09.656-.539l-.879-3.998a1.52 1.52 0 01.412-1.468l3.01-2.773c.282-.244.112-.777-.235-.816l-4.059-.282c-.511-.129-.884-.411-1.12-.886z" stroke={stroke} fill={fill} fillRule="nonzero" />;
    $[0] = fill;
    $[1] = stroke;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== className || $[4] !== height || $[5] !== t6 || $[6] !== width) {
    t7 = <svg width={width} height={height} viewBox="0 0 16 16" className={className}>{t6}</svg>;
    $[3] = className;
    $[4] = height;
    $[5] = t6;
    $[6] = width;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
IconStarFull.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.string
};
export default IconStarFull;